import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import { IApiListParams } from '@/types';
import { IAuditApiListResponse } from '@/types/audit';

export const auditList = (params: IApiListParams, config?: AxiosRequestConfig): Promise<AxiosResponse<IAuditApiListResponse>> => {
    return axios.get('/api/audit/list', { ...config, params });
};
